import { Injectable } from '@angular/core';
import {JobInsightsStatus, JobMetricsStatus, JobStatus} from '@/core/models/enums/job.enums';
import {VoiceJob} from "@/core/models/job.model";
import {Adapter} from "@/core/adapters/adapter";

@Injectable({
    providedIn: 'root'
})
export class VoiceJobAdapter implements Adapter<VoiceJob> {

    adaptList(data: any): VoiceJob[] {
        if (!Array.isArray(data.Jobs)) {
            console.error('[VoiceJobAdapter] Expected array but got:', data);
            return [];
        }

        return data.Jobs.map((item: any) => this.adapt(item));
    }

    adapt(data: any): VoiceJob {
        try {
            if (!data) {
                throw new Error('No voice job is given');
            }
            return new VoiceJob(
                data.job_id,
                this.mapStatus(data.status),
                this.mapMetricsStatus(data.metrics_status),
                data.created_at,
                data.started_at,
                data.duration_sec,
                data.result,
                data.error,
                data.filename,
                data.final_conversation_title,
                data.audio_url,
                data.video_url,
                data.finished_at,
                this.mapInsightsStatus(data.insights_status),
                data.insights_error,
                data.insights_generated_at
            );
        } catch (err) {
            console.error('[VoiceJobAdapter] Failed to adapt Voice Job:', err);
            // Optional: send to Sentry or remote logger here
            // Rethrow to bubble up
            throw err;
        }
    }

    private mapStatus(status: string): JobStatus {
        switch (status) {
            case 'queued':
                return JobStatus.QUEUED;
            case 'processing':
                return JobStatus.PROCESSING;
            case 'finished':
                return JobStatus.FINISHED;
            case 'failed':
                return JobStatus.FAILED;
            default:
                return JobStatus.QUEUED;
        }
    }

    private mapMetricsStatus(status: string): JobMetricsStatus {
        switch (status) {
            case 'not_started':
                return JobMetricsStatus.NOT_STARTED;
            case 'processing':
                return JobMetricsStatus.PROCESSING;
            case 'finished':
                return JobMetricsStatus.FINISHED;
            case 'failed':
                return JobMetricsStatus.FAILED;
            default:
                return JobMetricsStatus.NOT_STARTED;
        }
    }

    private mapInsightsStatus(insights_status: string): JobInsightsStatus {
        switch (insights_status) {
            case 'queued':
                return JobInsightsStatus.NOT_STARTED;
            case 'processing':
                return JobInsightsStatus.PROCESSING;
            case 'finished':
                return JobInsightsStatus.FINISHED;
            case 'failed':
                return JobInsightsStatus.FAILED;
            default:
                return JobInsightsStatus.NOT_STARTED;
        }
    }
}